import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Gender } from '../../../enums/DropDownDataTable';

const DeliveryPersonInfoReuse = props => {
    const { keyType, name, mobile, age, gender, onClickEdit, onClickDelete, index } = props;
    const [removePerson, setRemovePerson] = useState(false);

    const handleShowDel = () => {
        setRemovePerson(false);
        props.onClickDelete(index);
    };

    return (
        <div className="container" key={keyType}>
            <div className="row mt-1">
                <div className="col-8 f12-500 mt-1">{name}</div>
            </div>
            <div className="row mb-2 f11-400">
                <div className="col-2  opacity5 ">{gender[0] + " " + age}</div>
                <div className="col-3  opacity5 ">{"+91"+" "+mobile}</div>
                <div className="col-7 justify-content-center d-flex ">
                    <img src={require("../../../assets/images/ActionImages/mingcute_edit-line.png")}
                        width="24px" height="24px" alt="edit" className="mr-2" onClick={() => onClickEdit(index)} />
                    <img src={require("../../../assets/images/ActionImages/material-symbols_delete-outline.png")}
                        width="24px" height="24px" alt="delete"  onClick={handleShowDel} />
                </div>
            </div>
        </div>
    )
}

DeliveryPersonInfoReuse.propTypes = {
    name: PropTypes.string.isRequired, mobile: PropTypes.string.isRequired, age: PropTypes.string, onClickEdit: PropTypes.func.isRequired, onClickDelete: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    onDeleteConfirmed: PropTypes.func.isRequired,
}

export default DeliveryPersonInfoReuse